import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal";

const ConfigDPIProfilesHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="DPI Profiles"
      onClose={doClose}
      content={() => (
        <React.Fragment>
          <p>
            DPI Profiles. Classify flows based on a list of L7 domains obtained
            by DPI.
          </p>
          <ul>
            <li>
              <b>NAME</b>: Profile name.
            </li>
            <li>
              <b>PATTERN</b>: DPI pattern to match. Wildchar * is supported.
              Examples: "prefix*", "*suffix", "*substring*".
            </li>
            <li>
              <b>TYPE</b>: Type (HTTP, HTTPS, QUIC).
            </li>
            <li>
              <b>PRIORITY</b>: Evaluation priority. Lower numbers evaluated
              first. (Number from -9999 to 9999).
            </li>
          </ul>
          <p>
            Click on the <i className="material-icons valign-icon">edit</i> icon
            to edit an already configured profile.
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">delete</i>{" "}
            icon to delete all entries of the corresponding profile.
          </p>
          <p>
            Press the <i className="material-icons valign-icon">more_vert</i>{" "}
            icon and then select{" "}
            <ul>
              <li>
                <b>Add Profile...</b> to add a new profile.
              </li>
              <li>
                <b>Create/Update Predefined Profiles</b> to generate a set of
                profiles (mainly DPI) with the latest predefined signatures of
                the current software release.
              </li>
            </ul>
          </p>
          <p>
            Click on the <i className="material-icons valign-icon">refresh</i>{" "}
            icon to refresh profiles information.
          </p>
        </React.Fragment>
      )}
    />
  );
};

export default ConfigDPIProfilesHelpModal;
